
import * as UserActions from '../types/userTypes';
import * as AuthActions from '../types/authTypes';
import { userType } from 'redux/types/storeTypes';

const initialState: userType = {

};

const userReducer = (state = initialState, action: { [key: string]: any }) => {

  switch (action.type) {

    case UserActions.GET_USER_SUCCESS:
      return {
        ...state,
        ...action.payload,
      };

    case AuthActions.UPDATE_PROFILE_SUCCESS:
      return {
        ...state,
        ...(action.payload?.user ?? {})
      }

    default:
      return state;
  }
};

export default userReducer;
